import React from 'react';
import { connect } from "react-redux";
import {
    Box,
    FormControl,
    Grid,
    TextField,
    Typography,
    FormHelperText
} from '@mui/material';
import '../DevoteeDetailsComponent/DevoteeDetailsComponent.css';
import { getpujadetail } from '../../store/actions/puja.js';
import { useImmer } from 'use-immer';

const DevoteeDetailsComponent = ({

    Pujadetails,
    getpujahomauserdetails,
    setpujahomauserdetails

}) => {
    const ErrorInitialState = {
        error: false,
        message: ""
    }
    const [isNameSelected, setIsNameSelected] = useImmer(false);
    const [isContactNumberValid, setIsContactNumberValid] = useImmer(true);
    const [AltContactPersonError, setPersonAltContactPersonError] = useImmer(ErrorInitialState);
    const [MailPersonPinCodeError, setMailPersonPinCodeError] = useImmer(false);
    const [MailPersonMobileError, setMailPersonMobileError] = useImmer(false);
    const [pujaID, setPujaID] = useImmer('');

    const [isComments, setComments] = useImmer(ErrorInitialState);

    React.useEffect(() => {
        setPujaID(Pujadetails.PujaID);

    }, [Pujadetails])

    const handlePersonName = (event) => {
        setpujahomauserdetails((draft) => {
            draft.pujaUserName = event.target.value;
        })
        setIsNameSelected(event.target.value.trim() !== '');
    };


    const handlePersonContactNumber = (event) => {
        const contactNumber = event.target.value.trim();
        const isValid = /^[0-9]*$/;

        if (contactNumber.length <= 10 && isValid.test(contactNumber) && !/^0+$/.test(contactNumber)) {
            setpujahomauserdetails((draft) => {
                draft.pujaUserContact = contactNumber;
            });
            setIsContactNumberValid(true);
        } else {
            setIsContactNumberValid(false);
        }

        if (/^0+$/.test(contactNumber)) {
            setIsContactNumberValid(false);
        }

        if (
            contactNumber.length === 10 &&
            getpujahomauserdetails.pujaUserAlt.length === 10 &&
            contactNumber === getpujahomauserdetails.pujaUserAlt
        ) {
            setPersonAltContactPersonError((draft) => {
                draft.error = true;
                draft.message = "Contact Number and Alternate Number should not be the same";
            });
        } else if (
            getpujahomauserdetails.pujaUserAlt.length === 10 &&
            contactNumber !== getpujahomauserdetails.pujaUserAlt
        ) {
            setPersonAltContactPersonError((draft) => {
                draft.error = false;
                draft.message = "";
            });
        }
    };



    const handlePersonAltNumber = (event) => {
        const Alternatenumber = event.target.value.trim();
        const isValid = /^[0-9]*$/;

        if (Alternatenumber.length <= 10 && isValid.test(Alternatenumber) && !/^0+$/.test(Alternatenumber)) {
            setpujahomauserdetails((draft) => {
                draft.pujaUserAlt = Alternatenumber;
            });
            setPersonAltContactPersonError((draft) => {
                draft.error = false;
                draft.message = "";
            });
        }

        if (Alternatenumber.length > 0 && Alternatenumber.length < 10) {
            setPersonAltContactPersonError((draft) => {
                draft.error = true;
                draft.message = "Enter a valid mobile number";
            });
        }

        if (Alternatenumber === getpujahomauserdetails.pujaUserContact) {
            setPersonAltContactPersonError((draft) => {
                draft.error = true;
                draft.message = "Contact Number and Alternate Number should not be the same";
            });
        }

        if (/^0+$/.test(Alternatenumber)) {
            setPersonAltContactPersonError((draft) => {
                draft.error = true;
                draft.message = "";
            });
        }
    };

    const handleMailPersonName = (event) => {
        setpujahomauserdetails((draft) => {
            draft.pujamailName = event.target.value;
        })
    };
    const handleMailPersonAddress = (event) => {
        setpujahomauserdetails((draft) => {
            draft.pujamailAddress = event.target.value;
        })
    };
    const handleMailPersonPinCode = (event) => {
        let pincode = event.target.value;
        // Prevent leading spaces
        if (pincode.startsWith(' ')) {
            pincode = pincode.trimStart();
        }
        // Convert all alphabetic characters to uppercase
        pincode = pincode.toUpperCase();
        // Remove spaces for validation
        const pincodeNoSpaces = pincode.replace(/\s+/g, '');
        const regex = /^[A-Z0-9]*$/;
        if (pincode.length <= 10 && regex.test(pincodeNoSpaces)) {
            setpujahomauserdetails((draft) => {
                draft.pujamailPincode = pincode;
            });
        }
        // Show error if not empty and length not between 4 and 10 (excluding spaces), or contains non-alphanumeric
        if (
            (pincodeNoSpaces.length > 0 && (pincodeNoSpaces.length < 4 || pincodeNoSpaces.length > 10)) ||
            (pincodeNoSpaces.length > 0 && !regex.test(pincodeNoSpaces))
        ) {
            setMailPersonPinCodeError(true);
        } else {
            setMailPersonPinCodeError(false);
        }
    };
    const handleMailPersonMobile = (event) => {
        const personmobile = event.target.value.trim();
        const isValid = /^[0-9]*$/;

        if (personmobile.length <= 10 && isValid.test(personmobile) && !/^0+$/.test(personmobile)) {
            setpujahomauserdetails((draft) => {
                draft.pujamailMobile = personmobile;
            });
        }
    };

    const HandleEmail = (event) => {
        const email = event.target.value.trim().toLowerCase();
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

        setpujahomauserdetails((draft) => {
            draft.userEmail = email;
            draft.isEmailValid = emailRegex.test(email); // <-- Add this line
        });


        if (!emailRegex.test(email)) {
            setpujahomauserdetails((draft) => {
                draft.error = true;
                draft.message = "";
            });
        } else {
            setpujahomauserdetails((draft) => {
                draft.error = false;
                draft.message = "";
            });
        }
    };

    const HandlePan = (event) => {
        const Pan = event.target.value.trim().toUpperCase();
        const regpan = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;

        setpujahomauserdetails((draft) => {
            draft.userPanNo = Pan;
            draft.isPanValid = Pan === "" || regpan.test(Pan); // true if empty or valid
        });

        if (Pan !== "" && !regpan.test(Pan)) {
            setpujahomauserdetails((draft) => {
                draft.error = true;
                draft.message = "Please enter a valid PAN number";
            });
        } else {
            setpujahomauserdetails((draft) => {
                draft.error = false;
                draft.message = "";
            });
        }
    }

    const handleComments = (event) => {
        const Comments = event.target.value;
        if (Comments.length <= 120) {
            setpujahomauserdetails((draft) => {
                draft.userComments = Comments;
            });
            setComments((draft) => {
                draft.error = false;
                draft.message = "";
            });
        } else {
            setComments((draft) => {
                draft.error = true;
                draft.message = "Comments should not exceed 120 characters";
            });
        }
    }





    return (
        <>
            <Box
                className='DevoteeDetails'
                component="form"
                sx={{
                    '& .MuiTextField-root': { m: 1 },
                    mx: 20,
                    pt: 6
                }}
                noValidate
                autoComplete="off"
            >
                <div>
                    <Box className="form-control-spacing">
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={4}>
                                <Box>
                                    <label>Your Name  <span className='label-required'>*</span></label>
                                </Box>
                            </Grid>
                            <Grid item xs={12} sm={8}>
                                <FormControl fullWidth>
                                    <TextField id="outlined-basic" variant="outlined" value={getpujahomauserdetails.pujaUserName} onChange={handlePersonName} />
                                </FormControl>
                                {getpujahomauserdetails.pujaUserName == "" && (
                                    <FormHelperText error>Please enter Name</FormHelperText>
                                )}

                            </Grid>
                        </Grid>
                    </Box>
                    <Box className="form-control-spacing">
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={4}>
                                <Box>
                                    <label>Your Contact WhatsApp#  <span className='label-required'>*</span></label>
                                </Box>
                            </Grid>
                            <Grid item xs={12} sm={8}>
                                <FormControl fullWidth >
                                    <TextField id="outlined-basic"
                                        variant="outlined"
                                        type="text"
                                        inputMode='numeric'
                                        value={getpujahomauserdetails.pujaUserContact}
                                        onChange={handlePersonContactNumber}
                                    />
                                </FormControl>
                                {getpujahomauserdetails.pujaUserContact.length < 10 && (
                                    <FormHelperText error>Please enter a valid 10-digit contact number</FormHelperText>
                                )}
                            </Grid>
                        </Grid>
                    </Box>
                    <Box sx={{ mb: 4 }}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={4}>
                                <Box>
                                    <label>Your Email ID <span className='label-required'>*</span></label>
                                </Box>
                            </Grid>
                            <Grid item xs={12} sm={8}>
                                <FormControl fullWidth>
                                    <TextField
                                        id="outlined-basic"
                                        variant="outlined"
                                        value={getpujahomauserdetails.userEmail}
                                        onChange={HandleEmail}
                                    />
                                    {(getpujahomauserdetails.userEmail === "" ||
                                        (getpujahomauserdetails.userEmail !== "" && !getpujahomauserdetails.isEmailValid)) && (
                                            <FormHelperText error>
                                                Please enter valid email
                                            </FormHelperText>
                                        )}
                                </FormControl>
                            </Grid>
                        </Grid>
                    </Box>
                    <Box className="form-control-spacing">
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={4}>
                                <Box>
                                    <label>Alternate Mobile No#</label>
                                </Box>
                            </Grid>
                            <Grid item xs={12} sm={8}>
                                <FormControl fullWidth>
                                    <TextField id="outlined-basic"
                                        variant="outlined"
                                        type="text"
                                        value={getpujahomauserdetails.pujaUserAlt}
                                        onChange={handlePersonAltNumber}
                                    />
                                    {AltContactPersonError.error && (
                                        <FormHelperText error>{AltContactPersonError.message}</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                        </Grid>
                    </Box>
                    <Box>
                        <Box sx={{ mb: 4 }}>
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={4}>
                                    <Box>
                                        <label>Your PAN <span className='label-required'></span></label>
                                    </Box>
                                </Grid>
                                <Grid item xs={12} sm={8}>
                                    <FormControl fullWidth>
                                        <TextField
                                            id="outlined-basic"
                                            variant="outlined"
                                            value={getpujahomauserdetails.userPanNo}
                                            onChange={HandlePan}
                                            inputProps={{ maxLength: 10 }}
                                            error={getpujahomauserdetails.userPanNo !== "" && !getpujahomauserdetails.isPanValid}
                                        />
                                        {getpujahomauserdetails.userPanNo !== "" && !getpujahomauserdetails.isPanValid && (
                                            <FormHelperText error>
                                                Please enter valid Pan Number
                                            </FormHelperText>
                                        )}
                                    </FormControl>
                                </Grid>
                            </Grid>
                        </Box>
                        <Typography sx={{ pb: 4, fontWeight: '600', color: '#010101' }}>Please provide an Indian Mailing Address if you want Prasadam to be mailed:</Typography>
                        <Box sx={{ mb: 4 }}>
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={4}>
                                    <Box>
                                        <label>Name</label>
                                    </Box>
                                </Grid>
                                <Grid item xs={12} sm={8}>
                                    <FormControl fullWidth>
                                        <TextField id="outlined-basic" variant="outlined" value={getpujahomauserdetails.pujamailName} onChange={handleMailPersonName} />
                                    </FormControl>
                                </Grid>
                            </Grid>
                        </Box>
                        <Box className="form-control-spacing">
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={4}>
                                    <Box>
                                        <label>Address</label>
                                    </Box>
                                </Grid>
                                <Grid item xs={12} sm={8}>
                                    <FormControl fullWidth>
                                        <TextField multiline rows="4" id="outlined-basic" variant="outlined" value={getpujahomauserdetails.pujamailAddress} onChange={handleMailPersonAddress} />
                                    </FormControl>
                                </Grid>
                            </Grid>
                        </Box>
                        <Box className="form-control-spacing">
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={4}>
                                    <Box>
                                        <label>Pin Code</label>
                                    </Box>
                                </Grid>
                                <Grid item xs={12} sm={8}>
                                    <FormControl fullWidth>
                                        <TextField
                                            id="outlined-basic"
                                            variant="outlined"
                                            type="text"
                                            value={getpujahomauserdetails.pujamailPincode}
                                            onChange={handleMailPersonPinCode}
                                            error={MailPersonPinCodeError}
                                        />
                                        {MailPersonPinCodeError && (
                                            <FormHelperText error>
                                                Please enter valid Pincode
                                            </FormHelperText>
                                        )}
                                    </FormControl>
                                </Grid>
                            </Grid>
                        </Box>
                        <Box className="form-control-spacing">
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={4}>
                                    <Box>
                                        <label>Phone#</label>
                                    </Box>
                                </Grid>
                                <Grid item xs={12} sm={8}>
                                    <FormControl fullWidth>
                                        <TextField id="outlined-basic" variant="outlined" type="text" value={getpujahomauserdetails.pujamailMobile} onChange={handleMailPersonMobile} />
                                    </FormControl>
                                </Grid>
                            </Grid>
                        </Box>
                        <Box sx={{ mb: 4 }}>
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={4}>
                                    <Box>
                                        <label>Comments</label>
                                    </Box>
                                </Grid>
                                <Grid item xs={12} sm={8}>
                                    <FormControl fullWidth>
                                        <TextField
                                            id="outlined-multiline-flexible"
                                            multiline
                                            rows={4}
                                            value={getpujahomauserdetails.userComments}
                                            onChange={handleComments}
                                            error={isComments.error}
                                            inputProps={{ maxLength: 120 }}
                                        />
                                        <span>{getpujahomauserdetails.userComments.length}/120</span>
                                        {isComments.error && (
                                            <FormHelperText error>{isComments.message}</FormHelperText>
                                        )}
                                    </FormControl>
                                </Grid>
                            </Grid>
                        </Box>
                    </Box>
                </div>
            </Box>
        </>
    )
}
const mapStateToProps = (state) => {
    return {
        Pujadetails: state.puja.pujadetails
    };

}
export default connect(mapStateToProps, {
    getpujadetail,

})(DevoteeDetailsComponent);